export default __webpack_public_path__ + "static/media/foam-thumb.17b9da4c.jpg";